import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideModal, showModal } from '../../actions/modal.actions';
import Locations from "./Locations";

class LocationManagement extends Component {

	componentDidMount() {

		// Change navbar type and color
		document.title = 'Locations - camvio.cloud';
		this.props.changeNavBarType('default', 'Locations');
	}

	componentDidUpdate(prevProps) {
		if (prevProps.isShowAccessModal !== this.props.isShowAccessModal && this.props.isShowAccessModal === true) {
		}
	}

	componentWillUnmount() {
		this.props.hideModal();
	}

	render() {
		const { history, isShowAccessModal } = this.props;

		//If user is redirected from create-account page - show cpni pop-up
		if (
			isShowAccessModal === false &&
			history.location.state &&
			history.location.state.serviceOrderData
		) {
			return null;
		}

		return (
			<div className="cmv-container cmv-container-dashboard cmv-container-client-selected">
				{/*{accountInfoLoader ?
					<Loader/> :
					<AccountInfoBox hideAccountJournalIcon={true} accountInfo={accountInfo} hideCardsContainer={true}/>}*/}
				<Locations />
			</div>
		);
	}
}

// const loader = createLoadingSelector([ 'SET_ACCOUNT_DETAILS' ]);

const mapStateToProps = (state) => {
	// const accountInfo = getAccountDetails(state).accountDetails.accountInfo;
	// const accountInfoLoader = loader(state);
	//  showNewOrderWizard = getAccountDetails(state).accountDetails.showNewOrderWizard,
	// 	isShowAccessModal = getModalData(state).showAccessModal,

	return {
		// accountInfo,
		// accountInfoLoader
	};
};

const mapDispatchToProps = {
	showModal,
	hideModal
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationManagement);
